import GradeLessonPage from '../components/GradeLessonPage';
import { algebra1Data } from './data';

const topics = (algebra1Data.topics ?? []).map((topic: any) => ({
  id: topic.id,
  title: topic.title,
  icon: 'ri-functions',
  color: 'orange',
  skills: (topic.skills ?? []).map((skill: any) => ({
    id: skill.id,
    title: skill.title,
    standards: [
      ...(skill.standards?.commonCore ?? []),
      ...(skill.standards?.nctm ?? []),
    ],
    explanation: skill.explanation ?? '',
    questions: (skill.practiceQuestions ?? []).map((q: any) => ({
      q: q.question ?? '',
      steps: (q.solution ?? '').split('\n').filter((s: string) => s.trim()),
      answer: (() => {
        const lines = (q.solution ?? '').split('\n');
        const answerLine = lines.find((l: string) =>
          l.toLowerCase().includes('**answer')
        );
        return answerLine
          ? answerLine.replace(/\*\*/g, '').replace('Answer:', '').trim()
          : '';
      })(),
    })),
  })),
}));

export default function Algebra1Page() {
  return (
    <GradeLessonPage
      grade="Algebra 1"
      gradeLabel="Algebra 1"
      gradeColor="orange"
      topics={topics}
      prevGrade={{ label: 'Grade 8', path: '/grade/8' }}
      nextGrade={{ label: 'Geometry', path: '/geometry' }}
    />
  );
}
